import labels from "../../../config/labels";
import {
  Col,
  CustomContainer,
  Row,
  Form,
  DropdownButton,
  Dropdown,
  connect,
} from "../../atoms/DependencyHelper";
import styles from "./UpgradeTopContainer.module.scss";
import {
  componentCheckSize,
  createMarkup,
} from "../../../utils/helperServices";
import CTAButton from "../../atoms/CTAButton/CTAButton";
import config from "../../../config";
import { useState } from "react";
import { useEffect, useCallback } from "react";
import ButtonWithIcon from "../../atoms/buttons/buttonWithIcon/ButtonWithIcon";
import {
  displayHideUpgradeModal,
  updateMsisdnStatus,
  generateOTP,
  fetchAlternateNumbers,
  updateUpgradeRedirect,
  generateOneTimePin,
  updateUnmaskedMsisdn,
  updateCanReciveOTP,
  updateJourneyStatus,
  resetInvalidOtps,
} from "../../../Redux/actions/upgradeAction";
import {
  errorCodes,
  maskMsisdn,
  upgradeStages,
} from "../../../services/upgradeService";
import * as Analytics from "../../../services/analyticsUtag";

const UpgradeTopContainer = (props) => {
  const env = config.env;
  const numRegEx = RegExp(/^[0-9]*$/);
  const cellPhoneRegEx = RegExp(/^0[0-9]*$/);
  const msisdnRegEx = RegExp(/^27[0-9]*$/);
  const isMobile = componentCheckSize() < 577;
  const isTablet = componentCheckSize() < 992;
  const isDesktop = componentCheckSize() > 992;
  const [showAccordion, setShowAccordion] = useState(false);
  const [errorMessage, setErrorMessage] = useState();
  const imagePrefix = config.envConfigs[env].imagePrefix;
  let [isChecked, setCheckedState] = useState(true);
  const [isContinue, setisContinue] = useState(false);
  const [selectedRadio, setSelectedRadio] = useState(1);
  const [isPreviouslyChecked, setIsPreviouslyChecked] = useState(
    props.isPrevious
  );
  const [enteredCellNumber, setEnteredCellNumber] = useState("");
  const [isDefault, setIsDefault] = useState(!props.isPrevious);
  const [linkedNum, setLinkedNum] = useState(props.linkedNumbers);
  const [selectedAlternate, setSelectedAlternate] = useState();
  const handleContinue = () => {
    const utagViewData = Analytics.getUtagData([
      "page_channel",
      "page_master_tab",
      "page_site_section_lvl_1",
      "page_site_section_lvl_2",
      "page_site_section_lvl_3",
      "visitor_login_status",
      "visitor_customer_id",
      "visitor_id_hash",
      "visitor_msisdn_hash",
      "visitor_subscription_type",
    ]);
    utagViewData.page_name = getPageName();
    Analytics.link({
      link_type: "o",
      link_name: `${utagViewData.page_name}: continue`,
      ...utagViewData
    })
    if(props.selectedNumber)  {
      props.updateUnmaskedMsisdn(props.selectedNumber);
    }
    if (!props.isAlternate) {
      if (!isChecked) {
        setLinkedNum([]);
        setIsDefault(false);
        props.fetchAlternateNumbers(props.selectedNumber);
        props.setIsPrevious(false);
      } else {
        props.updateMsisdnStatus(maskMsisdn(props.selectedNumber), true);
        props.generateOneTimePin(props.selectedNumber).then(() => {
          props.displayHideUpgradeModal(!props.showUpgradeModal);
        });
      }
    } else {
      props.generateOTP(props.selectedNumber, selectedAlternate).then(() => {
        props.displayHideUpgradeModal(!props.showUpgradeModal);
      });
    }
  };

  const callbackRef = useCallback((inputFocus) => {
    if (!props.isPrevious) {
      setTimeout(() => {
        if (inputFocus) {
          inputFocus.focus();
        }
      }, [300]);
    }
  }, []);
  const handleBackStep = () => {
    props.setisAlternate(false);
    if (props.upgradeCheckDone) {
      props.setIsPrevious(true);
    } else {
      setIsDefault(true);
    }
    const utagViewData = Analytics.getUtagData([
      "page_channel",
      "page_master_tab",
      "page_site_section_lvl_1",
      "page_site_section_lvl_2",
      "page_site_section_lvl_3",
      "visitor_customer_id",
      "visitor_id_hash",
      "visitor_msisdn_hash",
      "visitor_subscription_type",
    ]);
    utagViewData.page_name = getPageName();
    Analytics.link({
      link_type: "o",
      link_name: `${utagViewData.page_name}: back`,
      ...utagViewData
    })
  };
  const handleSelectedDropdownNum = (item) => {
    props.updateMsisdnStatus(item, true);
    setSelectedAlternate(item);
    setisContinue(true);
  };
  const handleSelected = (item) => {
    setSelectedRadio(item.id);
    const utagViewData = Analytics.getUtagData([
      "visitor_login_status",
      "visitor_customer_id",
      "visitor_id_hash",
      "visitor_msisdn_hash",
      "visitor_subscription_type",
      "upgrade_eligibility_status",
      "upgrade_ineligible_reason",
      "upgrade_eligible_date",
      "upgrade_customer_type",
    ]);
    utagViewData.page_name = props.isPrevious
    ? "shopping: upgrade: eligibility: another number"
    : "shopping: upgrade: eligibility";
    if (item.id == 1) {
      props.setSelectedNumber(props.unMaskedMsisdn);
      setEnteredCellNumber("");
      setErrorMessage("");
      utagViewData.page_tool_name = `${utagViewData.page_name}: previous number select`;
    } else {
      props.setSelectedNumber();
      utagViewData.page_tool_name =  `${utagViewData.page_name}: another number select`;
    }
    Analytics.link({
      page_channel: "shopping",
      page_master_tab: "personal",
      page_site_section_lvl_1: "upgrade",
      page_site_section_lvl_2: "home",
      page_tool_event: "use",
      ...utagViewData,
    });
  };
  const handleCellNumber = (event) => {
    //reset Invalid OTP Tries if the number is different
    if(props.selectedNumber !== event.target.value) {
      props.resetInvalidOtps();
    }
    getErrorMessage(event.target.value);
    setEnteredCellNumber(event.target.value);
    props.setSelectedNumber(event.target.value);
  };
  const toggleChange = (event) => {
    setCheckedState(!isChecked);
    props.updateCanReciveOTP(!isChecked);
    const utagViewData = Analytics.getUtagData([
      "visitor_login_status",
      "visitor_customer_id",
      "visitor_id_hash",
      "visitor_msisdn_hash",
      "visitor_subscription_type",
      "upgrade_eligibility_status",
      "upgrade_ineligible_reason",
      "upgrade_eligible_date",
      "upgrade_customer_type",
    ]);
    utagViewData.page_name = props.isPrevious
    ? "shopping: upgrade: eligibility: another number"
    : "shopping: upgrade: eligibility";
    Analytics.link({
      ...utagViewData,
      page_tool_event: "use",
      page_tool_name: `${utagViewData.page_name}: ${ isChecked ? "I can't use sms":"I can use sms"}`,
      page_channel: "shopping",
      page_master_tab: "personal",
      page_site_section_lvl_1: "upgrade",
      page_site_section_lvl_2: "home",
    })
  };
  const getErrorMessage = (value) => {
    if (value && value.length > 0) {
      setErrorMessage("");
      if (numRegEx.test(value)) {
        if (!(cellPhoneRegEx.test(value) || msisdnRegEx.test(value))) {
          setErrorMessage("Number must start with 0 or 27 ");
        } else {
          setErrorMessage("");
        }
      } else {
        setErrorMessage("This field can only contain numbers");
      }
    } else {
      setErrorMessage("Please enter your cellphone number");
    }
  };
  const cellPhoneRadioOptions = [
    {
      id: 1,
      val: `The one I checked previously (${props.msisdn})`,
    },
    {
      id: 2,
      val: "Another cellphone number",
    },
  ];
  useEffect(() => {
    if (
      (props.selectedNumber &&
        props.selectedNumber.length == fetchMaxNumber() &&
        !errorMessage) ||
      (props.isPrevious && selectedRadio == 1)
    ) {
      setisContinue(true);
    } else {
      setisContinue(false);
    }
  }, [props.selectedNumber, isDefault]);

  const handleWonderClick = () => {
    if(!showAccordion){
      Analytics.link({
        page_tool_event: "use",
        page_tool_name: `${Analytics.getPageName()}: what to expect`,
        ...Analytics.getUtagData([
          "page_name",
          "page_channel",
          "page_master_tab",
          "page_site_section_lvl_1",
          "page_site_section_lvl_2",
          "page_site_section_lvl_3",
          "visitor_customer_id",
          "visitor_id_hash",
          "visitor_msisdn_hash",
          "visitor_subscription_type",
        ]),
      })
    }
    if (isTablet) {
      setShowAccordion(!showAccordion);
    } else {
      setShowAccordion(true);
    }
  };

  useEffect(() => {
    if (props.isAlternate) {
      setIsDefault(false);
      props.setIsPrevious(false);
      if (selectedAlternate) {
        setisContinue(true);
      } else {
        setisContinue(false);
      }
    } 
    if(props.isPrevious){
      setIsDefault(false)
    }
  }, [props.isAlternate, isDefault, props.isPrevious]);
  useEffect(() => {
    setLinkedNum(props.linkedNumbers);
  }, [props.linkedNumbers]);

  useEffect(() => {
    if (linkedNum.length > 0) {
      //props.displayHideUpgradeModal(false); //Need to comment this out since this causes modal popup not to appear in alternative numbers
      setIsDefault(false);
      props.setisAlternate(true);
    } else {
      if ((props.isAlternate || !isChecked) && props.upgradeStatus === upgradeStages.TECHNICAL_ERROR) { 
        props.setisAlternate(false);
        props.displayHideUpgradeModal(true);
      }
      setIsDefault(!props.isPrevious);
    }
  }, [linkedNum, props.upgradeStatus]);
  const fetchMaxNumber = () => {
    let maxNumber = 11;
    if (cellPhoneRegEx.test(props.selectedNumber)) {
      maxNumber = 10;
    }
    return maxNumber;
  };

  const getPageName = ()=>{
    if(props.isAlternate){
      return "shopping: upgrade: eligibility: send otp"
    } else {
      return props.isPrevious
      ? "shopping: upgrade: eligibility: another number"
      : "shopping: upgrade: eligibility"
    }
  }

  useEffect(() => {
    if (errorMessage) {
      Analytics.link({
        page_name: props.isPrevious
          ? "shopping: upgrade: eligibility: another number"
          : "shopping: upgrade: eligibility",
        page_form_name: `shopping: upgrade: forms: ${
          isMobile
            ? labels.lbl_upgrade_page_heading_mobile
            : labels.lbl_upgrade_page_heading
        }`,
        page_form_event: "error",
        page_errors: errorMessage,
        page_error_type: "form",
      });
    }
  }, [errorMessage]);

  return (
    <CustomContainer className={styles["upgrade-top-container"]}>
      <CustomContainer className={styles["upgrade-top-container__paragraph"]}>
        <CustomContainer
          className={styles["upgrade-top-container__paragraph__heading"]}
        >
          {isMobile
            ? labels.lbl_upgrade_page_heading_mobile
            : labels.lbl_upgrade_page_heading}
        </CustomContainer>
        <CustomContainer
          className={styles["upgrade-top-container__paragraph__description"]}
        >
          {labels.lbl_upgrade_page_description}
        </CustomContainer>
      </CustomContainer>
      <Row className={styles["upgrade-top-container__otp"]}>
        <Col
          lg={7}
          md={12}
          xs={12}
          className={`${styles["upgrade-top-container__otp__number-input"]} ${styles["otp-section"]}`}
        >
          <CustomContainer
            className={
              styles["upgrade-top-container__otp__number-input__heading"]
            }
          >
            {!props.isAlternate && (
              <CustomContainer
                className={
                  styles[
                    "upgrade-top-container__otp__number-input__heading__image"
                  ]
                }
              >
                <img
                  src={`${imagePrefix}/assets/images/signed-profile.svg`}
                  width={24}
                  height={24}
                />
              </CustomContainer>
            )}

            <CustomContainer>
              {props.isAlternate && (
                <>
                  <ButtonWithIcon
                    className={styles["back-btn"]}
                    labelText="Back"
                    img_url_inactive={`${imagePrefix}/assets/images/caret-back.svg`}
                    img_url_active={`${imagePrefix}/assets/images/caret-back.svg`}
                    img_width={12}
                    img_height={12}
                    clickHandler={handleBackStep}
                  />
                  <span
                    className={
                      styles[
                        "upgrade-top-container__otp__number-input__heading__image"
                      ]
                    }
                  >
                    <img
                      src={`${imagePrefix}/assets/images/alternate-msg.svg`}
                      width={24}
                      height={24}
                    />
                  </span>
                  <span className={styles["where-can-heading"]}>
                    {"Where can we send your OTP ?"}
                  </span>
                </>
              )}
            </CustomContainer>
            {isMobile && (
              <CustomContainer className={styles["default-heading"]}>
                {" "}
                {!props.isAlternate && labels.lbl_which_number_mobile}
              </CustomContainer>
            )}
            {!isMobile && (
              <CustomContainer className={styles["default-heading"]}>
                {" "}
                {!props.isAlternate && labels.lbl_which_number}
              </CustomContainer>
            )}
          </CustomContainer>
          {props.isPrevious && !props.isAlternate &&(
            <CustomContainer>
              {cellPhoneRadioOptions?.length > 0 &&
                cellPhoneRadioOptions.map((item, index) => (
                  <CustomContainer className={`mb-l`} key={`phone-${item.id}-${index}`}>
                    <label htmlFor={`radio-btn-${item.id}`}>
                      <input
                        type="radio"
                        name={"cellPhone"}
                        checked={item.id == selectedRadio}
                        id={`radio-btn-${item.id}`}
                        onClick={() => handleSelected(item)}
                      />
                      <span
                        className={`${styles["previous-radio-label"]} ${
                          item.id == selectedRadio ? styles["selected-num"] : ""
                        }`}
                      >
                        {item.val}
                      </span>
                    </label>
                  </CustomContainer>
                ))}
              <CustomContainer
                className={
                  props.isPrevious &&
                  selectedRadio == 1 &&
                  styles["disabled"]
                }
              >
                <CustomContainer className={styles["cell-phone"]}>
                  {" "}
                  Cellphone number
                </CustomContainer>
                <label className={styles["cell-label"]}>
                  <input
                    type="text"
                    onChange={(event) => handleCellNumber(event)}
                    name="cellNumber"
                    value = {enteredCellNumber}
                    maxLength={fetchMaxNumber()}
                    placeholder={"Enter your cellphone number"}
                    ref={callbackRef}
                    className={`${styles["cell-number"]} ${
                      errorMessage && styles["error-input"]
                    }`}
                    autofocus
                  />
                </label>
                {errorMessage && (
                  <CustomContainer className={styles["error"]}>
                    {errorMessage}
                  </CustomContainer>
                )}
              </CustomContainer>
            </CustomContainer>
          )}
          {props.isAlternate && (
            <CustomContainer>
              <CustomContainer className={styles["cell-phone"]}>
                {"Alternative cellphone number"}
              </CustomContainer>
              <DropdownButton
                id="dropdown-basic-button"
                bsPrefix={styles["drop-down"]}
                title={selectedAlternate ? selectedAlternate : "-Select-"}
              >
                {linkedNum &&
                  linkedNum.map((item, index) => (
                    <CustomContainer key={`linked-${index}`} className={styles["drop-down-item"]}>
                      <Dropdown.Item
                        onClick={() => handleSelectedDropdownNum(item)}
                      >
                        {item}
                      </Dropdown.Item>
                    </CustomContainer>
                  ))}
              </DropdownButton>
            </CustomContainer>
          )}
          {isDefault && (
            <CustomContainer>
              <CustomContainer className={styles["cell-phone"]}>
                {" "}
                Cellphone number
              </CustomContainer>
              <label className={styles["input-label-container"]}>
                <input
                  type="text"
                  onChange={(event) => handleCellNumber(event)}
                  value={props.selectedNumber}
                  placeholder={"Enter your cellphone number"}
                  name="cellNumber"
                  maxLength={fetchMaxNumber()}
                  ref={callbackRef}
                  className={`${styles["cell-number"]} ${
                    errorMessage && styles["error-input"]
                  }`}
                  placeholder="Enter your cellphone number"
                />
              </label>
              {errorMessage && (
                <CustomContainer className={styles["error"]}>
                  {errorMessage}
                </CustomContainer>
              )}
            </CustomContainer>
          )}

          {!props.isAlternate && (
            <CustomContainer
              className={`${styles["checkbox-container"]} ${
                props.isPrevious && selectedRadio == 1 && styles["disabled"]
              }`}
            >
              <label className={styles["checkbox-label"]}>
                <input
                  type="checkbox"
                  id={props.id}
                  value="check-one"
                  checked={isChecked}
                  onChange={(event) => toggleChange(event)}
                  className={styles["checkbox-input"]}
                />
                <span
                  className={styles["checkbox-span"]}
                  dangerouslySetInnerHTML={createMarkup(
                    "I can receive an SMS on this number"
                  )}
                ></span>
              </label>
            </CustomContainer>
          )}
          <CustomContainer
            className={`${
              !isContinue && styles["disabled"]
            } static-button-wrapper`}
          >
            <CTAButton
              type="submit"
              className={`static-button ${styles["main-cta"]}`}
              variant="solid red"
              id="static-special-needs-form-submit"
              disabled={!isContinue}
              handleClick={handleContinue}
            >
              Continue
            </CTAButton>
          </CustomContainer>
        </Col>
        <Col
          className={`${styles["upgrade-top-container__otp__what-to-expect"]} ${styles["otp-section"]}`}
        >
          <CustomContainer
            className={styles["upgrade-top-container__accordion__heading"]}
            onClick={handleWonderClick}
          >
            {props.staticText.title}
            <CustomContainer>
              {(isTablet || isMobile) && !showAccordion && (
                <img
                  src={`${imagePrefix}/assets/images/chevron-down-black.svg`}
                  width={18}
                  height={9}
                />
              )}
              {(isTablet || isMobile) && showAccordion && (
                <img
                  src={`${imagePrefix}/assets/images/chevron-up-black.svg`}
                  width={18}
                  height={9}
                />
              )}
            </CustomContainer>
          </CustomContainer>
          {(isDesktop ? isDesktop : showAccordion) &&
            props?.staticText &&
            props?.staticText?.items.map((item, index) => (
              <CustomContainer key={`static-${index}`} className={styles["offers-text"]}>
                <span className={styles["offers-text__icon"]}>
                  <img src={item.icon} height={24} />
                </span>
                <CustomContainer
                  className={styles["offers-text__description"]}
                  dangerouslySetInnerHTML={createMarkup(item.description)}
                ></CustomContainer>
              </CustomContainer>
            ))}
        </Col>
      </Row>
    </CustomContainer>
  );
};

const mapStateToProps = (state) => ({
  showUpgradeModal: state.upgrade.showModal,
  upgradeCheckDone: state.upgrade.upgradeCheckDone,
  upgradeResponse: state.upgrade.upgradeResponse,
  displayData: state.upgrade.displayData,
  linkedNumbers: state.upgrade.linkedNumbers,
  msisdn: state.upgrade.msisdn,
  upgradeStatus: state.upgrade.upgradeStatus,
  unMaskedMsisdn: state.upgrade.unMaskedMsisdn,
  allUpgradesData: state.upgrade.allUpgradesData,
});

export default connect(mapStateToProps, {
  displayHideUpgradeModal,
  generateOneTimePin,
  updateMsisdnStatus,
  generateOTP,
  fetchAlternateNumbers,
  updateUpgradeRedirect,
  updateUnmaskedMsisdn,
  updateCanReciveOTP,
  updateJourneyStatus,
  resetInvalidOtps,
})(UpgradeTopContainer);
